/* eslint-disable import/no-extraneous-dependencies */
import axios from 'axios';
import Cookies from 'js-cookie';
import api from '~/services/api';
import {
  // CONVERSION_API_META_PIXEL_ID,
  // CONVERSION_API_META_TOKEN,
  Connection,
} from '~/services/config';
import {
  getStorageTracking,
  updateStorageTracking,
} from '~/storage/StorageTracking';
// import { generateHashSHA256 } from './crypto';

export async function getTtclid(userregistrationtracking) {
  try {
    const cookieTtclid = Cookies.get('ttclid');
    const storageTracking = getStorageTracking();

    if (userregistrationtracking && userregistrationtracking.data) {
      const { tiktok_ttclid } = userregistrationtracking.data.trackings;

      if (
        tiktok_ttclid &&
        tiktok_ttclid !== '' &&
        tiktok_ttclid !== undefined
      ) {
        updateStorageTracking({ ttclid: tiktok_ttclid });
        return tiktok_ttclid;
      }

      if (cookieTtclid) {
        const result = await api.put('/userregistrationtracking', {
          tiktok_ttclid: cookieTtclid,
        });

        return result.data.trackings.tiktok_ttclid;
      }

      if (storageTracking && storageTracking.ttclid) {
        const result = await api.put('/userregistrationtracking', {
          tiktok_ttclid: storageTracking.ttclid,
        });

        return result.data.trackings.tiktok_ttclid;
      }

      return userregistrationtracking.data.trackings.tiktok_ttclid;
    }

    return cookieTtclid;
  } catch (err) {
    console.log('Erro ao verificar ttclid', err);
  }
}

export async function getTtp(userregistrationtracking) {
  try {
    const cookieTtp = Cookies.get('_ttp');
    const storageTracking = getStorageTracking();

    if (userregistrationtracking && userregistrationtracking.data) {
      const { tiktok_ttp } = userregistrationtracking.data.trackings;

      if (tiktok_ttp && tiktok_ttp !== '' && tiktok_ttp !== undefined) {
        updateStorageTracking({ ttp: tiktok_ttp });
        return tiktok_ttp;
      }

      if (cookieTtp) {
        const result = await api.put('/userregistrationtracking', {
          tiktok_ttp: cookieTtp,
        });

        return result.data.trackings.tiktok_ttp;
      }

      if (storageTracking && storageTracking.ttclid) {
        const result = await api.put('/userregistrationtracking', {
          tiktok_ttp: storageTracking.ttp,
        });

        return result.data.trackings.tiktok_ttp;
      }

      return userregistrationtracking.data.trackings.tiktok_ttp;
    }

    return cookieTtp;
  } catch (err) {
    console.log('Erro ao verificar ttp', err);
  }
}
//
export async function ConversionApiTiktok({
  eventId,
  eventName,
  email,
  phone,
  externalId,
  ttclid,
  ttp,
}) {
  try {
    // console.log('ttclid ----------->', tiktok_ttclid);

    const data = {
      eventName,
    };

    if (ttclid && ttclid !== '' && ttclid !== undefined) {
      data.ttclid = ttclid;
    }

    if (ttp) {
      data.ttp = ttp;
    }

    if (eventId) {
      data.eventId = eventId;
    }

    if (externalId) {
      data.externalId = externalId;
    }

    if (email) {
      data.email = email;
    }

    if (phone) {
      data.phone = phone;
    }

    if (window.location.href) {
      data.eventSourceUrl = window.location.href;
    }

    try {
      await axios.get('https://api64.ipify.org/?format=json').then(response => {
        if (response.data && response.data.ip) {
          data.clientIpAddress = response.data.ip;
        }
      });
    } catch (err) {
      console.log(err);
    }

    // console.log('Tiktok API Conversion ----------->', data);
    const result = await axios.post(
      `${Connection.url_conversion_api}/tiktok/apiconversion`,
      data
    );

    return result;
  } catch (err) {
    console.log('Erro ao enviar evento do Pixel Tiktok', err);
  }
}
